@import 'styles/mixins';
@import 'styles/variables';

.stepper {
  display: flex;
  align-items: center;
  border-radius: 6px;
  background: var(--neutral-0);
  @include shadow-3;
  gap: 4px;

  .steps {
    @include xs-regular;
    color: var(--neutral-30);
  }
}
